import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">探索不同类型的漫画，找到你的最爱</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {comicCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-4 p-5 bg-background-50 rounded-lg hover:bg-background-50/80 transition-all duration-300 cursor-pointer border border-background-200/60"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.count} 部作品</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors ml-auto w-5 h-5 flex items-center justify-center"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}